var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppSwitcherCaretBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.957 5C4.77432 4.99999 4.59513 5.05002 4.43888 5.14466C4.28263 5.2393 4.15529 5.37493 4.07068 5.53684C3.98607 5.69874 3.94742 5.88072 3.95894 6.06304C3.97045 6.24535 4.03169 6.42103 4.136 6.571L6.769 10.355C6.90717 10.5534 7.09128 10.7155 7.30562 10.8275C7.51996 10.9394 7.75819 10.9979 8 10.9979C8.24181 10.9979 8.48004 10.9394 8.69438 10.8275C8.90872 10.7155 9.09283 10.5534 9.231 10.355L11.864 6.571C11.9683 6.42103 12.0295 6.24535 12.0411 6.06304C12.0526 5.88072 12.0139 5.69874 11.9293 5.53684C11.8447 5.37493 11.7174 5.2393 11.5611 5.14466C11.4049 5.05002 11.2257 4.99999 11.043 5H4.957Z",
    fill: "#2D3748"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppSwitcherCaretBase);
export default __webpack_public_path__ + "static/media/app-switcher-caret-base.3b29dc44bde26f8a0eea787535a418b8.svg";
export { ForwardRef as ReactComponent };